import React, { useState, useEffect } from "react";
import { withRouter, Link } from 'react-router-dom';
import { handleFieldError } from "../../../../utils/form-validation";
import asyncRoute from '../../../../helpers/hoc/asyncRoute';

const Input = asyncRoute(() => import('../../../../components/FormElements/Input'));

const DetailCard = ({ item, form, setForm, touched, setTouched, errors, setErrors, formFields, isEditMode, submited }) => {
    const handleChange = (e) => {
        const { name, value } = e.target;
        const newForm = { ...form };
        newForm[e.target.name] = value;
        setForm(newForm);
    };

    const handleTouch = (e) => {
        const newTouched = { ...touched };
        const newErrors = { ...errors };
        const { error } = handleFieldError(e.target.value, formFields[e.target.name]);
        newErrors[e.target.name] = error;
        newTouched[e.target.name] = true;
        setTouched(newTouched);
        setErrors(newErrors);
    };

    return (
        <>
            {
                item.show ?
                    <>
                        {
                            item.link ?
                                <div className='col-md-3 pt-3'>
                                    <Link style={{ textDecoration: 'none' }} to={item.link}>
                                        <div className='title text-left font-weight-normal' style={{ color: "#707B8A", fontSize: 12 }}>{item.label}</div>
                                        <div className='detail' style={{ color: "#1B2559", fontSize: 14 }}>{item.value ? item.value : '-'}  
                                            {item.value ?
                                                <i class="ti ti-external-link ti-xs me-2 text-primary"></i>
                                                :
                                                null
                                            }
                                        </div>
                                    </Link>
                                </div>
                                :
                                <div className='col-md-3 pt-3'>
                                    <div className='title text-left font-weight-normal' style={{ color: "#707B8A", fontSize: 12 }}>{item.label}</div>
                                    {
                                        item.edit && isEditMode ?
                                            <Input
                                                onChange={handleChange}
                                                onBlur={handleTouch}
                                                value={form[item.formKey]}
                                                setting={formFields[item.formKey]}
                                                error={errors[item.formKey]}
                                                submited={submited}
                                                // disabled={true}
                                                touched={touched[item.formKey]} />
                                            :
                                            <div className='detail' style={{ color: "#1B2559", fontSize: 14 }}>{item.value ? item.value : '-'}</div>
                                    }
                                </div>
                        }
                    </>
                    :
                    null
            }
        </>
    )
};

export default DetailCard;